import { render, staticRenderFns } from "./updateMedicalVisit.vue?vue&type=template&id=3859ed89&"
import script from "./updateMedicalVisit.vue?vue&type=script&lang=js&"
export * from "./updateMedicalVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports